import { makeObservable, observable, flow, action, computed } from "mobx";
import { toast } from "sonner";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import CreateItemSchema from "@/areas/inventory/schemas/CreateItemSchema";

export default class CreateItemStore {
  visible = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  get canCreate() {
    return (
      this.parentStore.parentStore.authenticationStore.isAdmin ||
      this.parentStore.parentStore.authenticationStore.isAgent
    );
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save(data, options) {
    const parseResult = CreateItemSchema.safeParse(data);
    if (!parseResult.success) {
      return parseResult;
    }

    try {
      // Send what the schema produced, not the raw form values: an unset label is normalised to
      // null there, and the raw { id: null } would read to the API as a malformed label.
      const response = yield api.post(ApiRoutes.forItems(), parseResult.data);
      this.visible = false;
      toast.success("Item created successfully");
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while creating item", {
        description: e.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    }
  }
}
